<style scoped lang="scss">
@import '~guest-variables';

.modal-mask {
    position: fixed;
    z-index: 9999999999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;

        .modal-container {
            margin: 0px auto;
            transition: all 0.3s ease;
            position: relative;

            .modal-image {
                width: 100%;
            }

            .controls {
                position: absolute;
                bottom: -0.5rem;
                left: 50%;
                transform: translateX(-50%) translateY(100%);
                padding: 0 .5rem;
                background-color: rgba(255, 255, 255, 0.6);
                border-radius: $border-radius;
                white-space: nowrap;

                img {
                    height: 30px;
                    margin: 1rem .5rem;
                }
            }
        }
    }
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

</style>

<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click.self="$emit('close')">
                <div class="modal-container" ref="container">

                    <div class="corners" @click="$emit('close')">
                        <div class="c1"></div>
                        <div class="c2"></div>
                        <div class="c3"></div>
                        <div class="c4"></div>
                        <img class="modal-image" v-load-img :data-url="images[index].thumbs[imageWidth]">
                    </div>

                    <div class="controls">
                        <a @click="previous()">
                            <img src="/images/next.svg">
                        </a>
                        <a @click="next()">
                            <img class="r-180" src="/images/next.svg">
                        </a>
                        <a @click="$emit('close')">
                            <img src="/images/close.svg">
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {

        props: {
            startIndex: Number,
            images: Array,
        },

        data() {
            return {
                index: 0,
                delay: null,
                imageWidth: 'x150',
            };
        },

        created() {
            document.body.classList.add('noscroll');
            this.index = this.startIndex;

            window.addEventListener('resize', this.calcHeight);
            window.addEventListener('keyup', this.keyUp);
            setTimeout(() => {
                this.calcHeight();
            });
        },

        destroyed() {
            window.removeEventListener('resize', this.calcHeight);
            window.removeEventListener('keyup', this.keyUp);
            document.body.classList.remove('noscroll');
        },

        methods: {

            calcHeight() {
                if (window.clientWidth < 150) {
                    this.imageWidth = 'x150';
                } else if (window.clientWidth < 250) {
                    this.imageWidth = 'x250';
                } else if (window.clientWidth < 400) {
                    this.imageWidth = 'x400';
                } else if (window.clientWidth < 500) {
                    this.imageWidth = 'x500';
                } else if (window.clientWidth < 800) {
                    this.imageWidth = 'x800';
                } else {
                    this.imageWidth = 'x1024';
                }

                if (this.delay) {
                    clearTimeout(this.delay);
                }
                if (!this.$refs['container']) {
                    return;
                }

                const image = this.images[this.index];
                this.$refs['container'].style.width = ((image.metadata.width * this.getFactor(image)) - 62) *.8 + 'px';
            },

            getFactor(file) {
                return Math.min((window.innerWidth / file.metadata.width), (window.innerHeight / file.metadata.height));
            },

            next() {
                if (this.index === this.images.length - 1) {
                    this.index = 0;
                } else {
                    this.index++;
                }

                this.calcHeight();
            },

            previous() {
                if (this.index === 0) {
                    this.index = this.images.length - 1;
                } else {
                    this.index--;
                }

                this.calcHeight();
            },

            keyUp(event) {
                if (event.keyCode === 40 || event.keyCode === 37) {
                    this.previous()
                } else if (event.keyCode === 38 || event.keyCode === 39) {
                    this.next()
                } else if (event.keyCode === 27) {
                    this.close();
                }
            }

        },

    }
</script>
